export const login = "/auth/login";
export const verifyUser = "/auth/verify-user";
export const forgotPassword = "/auth/forgot-password";
export const getOtp = "/auth/verify-otp";
export const getNewPassWord = "/auth/reset-password";
export const getOverViewData = "/dashboard/dashboard-overview-data";
export const ticketListData = "/dashboard/get-dashboard-data";
export const getDashboardFilesData = "/dashboard/get-dashboard-files-data";
export const getPacDetails = "/ticketCreation/get-pac-details";
export const getDepartment = "/ticketCreation/get-department";
export const getModule = "/ticketCreation/get-module";
export const getTask = "/ticketCreation/get-task";
export const getSeverity = "/ticketCreation/get-severity";
export const uploadFileImage = "/masterdata/upload-file";
export const createTicket = "/ticketCreation/create-ticket";
export const getDCBCodes = "/dashboard/dccb-code";
export const updateTicket = "/ticketCreation/update-ticket";
export const downloadFile = "/masterdata/download-file";
export const getRolesData = "/ticketCreation/get-role";
export const getState = "/admin/state";
export const getUserType = "/admin/user-type";
export const getDccb = "/admin/dccb";
export const getAuditSummary = "/dashboard/get-audit-summary";
export const createUser = "/admin/create-user";
export const getUserDetails = "/userlist/get-user-details";
export const deleteUser = "/updateUser/delete-user";
export const updateEmailPhone = "/updateUser/email_mobile";
export const updateUserDetails = "/updateUser/update-user";
export const reSendOTP = "/auth/resend-otp";
export const createIntellectTicket = "/Intellect/ticket-assigned-to-intellect/";
export const getIntellectStatus = "/Intellect/get_ticket_details_status_and_comments/";
export const updatePassword = "/auth/update-password";
export const multipleDownloadFile = "/masterdata/multiple-file-zip";
export const intellectTicketReopen = "/Intellect/ticket_reopen/";
export const memberUpload ="/masterdata/attachment-file";
export const getUserStatus = "/admin/user-status";
export const addCommentIntellect  = "/Intellect/add_comment_to_the_intellect_ticket/"

